import {Box, IconButton, Rating} from "@mui/material";
import RestoreIcon from '@mui/icons-material/Restore';
import React, {useEffect, useState} from "react";
import {useTheme} from "../../contexts/theme";
import StyledIconButton from "../CommonComponents/StyledIconButton/StyledIconButton";
import {updateClip} from "../../queries/clipQueries";

export interface CustomRatingProps {
    auto_rating: number;
    manual_rating?: number | null;
    clipId: string;
}

const CustomRating = ({auto_rating, manual_rating, clipId} : CustomRatingProps) => {
    const theme = useTheme();
    const [tempManualRating, setTempManualRating] = useState<number | null>(null);
    const [tempAutoRating, setTempAutoRating] = useState<number>(0);

    useEffect(() => {
        setTempAutoRating(auto_rating);
    }, [auto_rating]);

    useEffect(() => {
        if(manual_rating !== undefined) {
            setTempManualRating(manual_rating);
        }
    }, [manual_rating]);

    const handleResetRatingValue = async () => {
        setTempManualRating(null);
        await updateClip(clipId, -1);
    }

    async function updateRatingValue(ratingValue: number | null) {
        setTempManualRating(ratingValue);
        await updateClip(clipId, ratingValue);
    }

    return (
        <Box display={'flex'} alignItems={'center'} height={'24px'}>
            <Rating
                name="read-only"
                value={tempManualRating ?? tempAutoRating}
                precision={0.5}
                sx={{ fontSize: '15px', "& .MuiRating-iconEmpty": { color: theme.palette.blue }, marginRight: theme.spacing.xs }}
                onChange={(event, newValue) => {
                    if (newValue) updateRatingValue(newValue)
                }}
            />
            {tempManualRating !== null && (
                <StyledIconButton onClick={handleResetRatingValue} width={'5px'} height={'5px'}>
                    <RestoreIcon sx={{ fontSize: 15 }} />
                </StyledIconButton>
            )}
        </Box>
    );
}

export default CustomRating;